import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from '../ui/button';
import { NotificationCenter } from './NotificationCenter';
import { useAuth } from '../../context/AuthContext';

export const AdminNavbar = ({ title }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <nav className="bg-white border-b sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/admin/dashboard">
            <h1 className="text-xl font-bold hover:text-primary transition-colors">
              {title || 'Admin Panel'}
            </h1>
          </Link>
          <div className="flex items-center gap-2">
            <NotificationCenter />
            <Button
              variant="outline"
              onClick={handleLogout}
              className="rounded-full"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};
